import * as React from 'react';
import './ForgotUserIdView.scss';
import ForgotUserId from './components/ForgotUserId';

export function ForgotUserIdView() {
  return (
    <div className="rp-forgotuseridview">
      <ForgotUserId />
    </div>
  );
}
